import { Typography } from "@mui/material";
import { useSelector } from "react-redux";

const VitalsView = ({ vitals }) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  return (
    <div className="ph10">
      {(vitals ?? reqDet?.vitals)?.map((vit) => {
        const vitalData = vit?.data?.[0] ?? {};
        return (
          <div className="gray-back-con" key={vit?.vitalId}>
            <div className="flex-row-ali-cen flex-row-wrap">
              <div className="gray-dot" />
              <Typography className="black fs12 font-bold ml5">
                {vit?.vitalGroup}
              </Typography>

              {Object.entries(vitalData)?.map(([key, value]) => (
                <div className="flex-row-ali-cen ml5" key={key}>
                  <div className="gray-dot" />
                  <Typography className="black fs12 font-bold ml5">
                    {key}: {value?.value ?? value}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VitalsView;
